/* global axios */

// Per-assistant MCP server attachments. Doubly-scoped (account +
// assistant) so we don't subclass ApiClient — its `url` getter assumes
// a single resource. We build URLs explicitly using the same
// account-id-from-route convention ApiClient uses internally.
// Free helper because `this` isn't used by the lookup. Lints clean
// either way; `this`-less methods are flagged by class-methods-use-this.
const currentAccountId = () => {
  if (window.location.pathname.includes('/app/accounts')) {
    return window.location.pathname.split('/')[3];
  }
  return '';
};

class CaptainAssistantMcpServers {
  // eslint-disable-next-line class-methods-use-this
  baseUrl(assistantId) {
    return `/api/v1/accounts/${currentAccountId()}/captain/assistants/${assistantId}/mcp_servers`;
  }

  index(assistantId) {
    return axios.get(this.baseUrl(assistantId));
  }

  // Attach a server to the assistant (or update an existing attachment's
  // enabled_tools). Idempotent server-side via find_or_initialize_by.
  attach(assistantId, { serverId, enabledTools = null }) {
    return axios.post(this.baseUrl(assistantId), {
      captain_mcp_server_id: serverId,
      enabled_tools: enabledTools,
    });
  }

  // The route uses the *server* id as its `:id` param so the URL reads
  // naturally: /captain/assistants/X/mcp_servers/Y means "the link to
  // server Y on assistant X".
  updateEnabledTools(assistantId, serverId, enabledTools) {
    return axios.put(`${this.baseUrl(assistantId)}/${serverId}`, {
      enabled_tools: enabledTools,
    });
  }

  detach(assistantId, serverId) {
    return axios.delete(`${this.baseUrl(assistantId)}/${serverId}`);
  }
}

export default new CaptainAssistantMcpServers();
